import * as React from 'react';
import TextField from '@mui/material/TextField';

export default function DateAppuntamento({setGiorniPreferiti, numeroData, GiorniPreferiti}) {
  return (
      <TextField
        onChange={e => setGiorniPreferiti(e.target.value)}
        id="datetime-local"
        label={numeroData}
        type="datetime-local"
        value={GiorniPreferiti || Date.now()}
        sx={{ width: 250 }}
        InputLabelProps={{
          shrink: true,
        }}
      />
  );
}